import type { MorningBriefing } from '../lib/morning-briefing';

/** Same labels and order as the API's narrativeSections, which email, Slack and audio render. */
export function narrativeBlocks(n: MorningBriefing['narrative']): Array<{ label: string; lines: string[] }> {
  if (!n) return [];
  return ([['Risks', n.risks], ['Decisions', n.decisions], ['Meetings', n.meetings], ['Shipped', n.shipped]] as const)
    .filter(([, lines]) => lines.length > 0)
    .map(([label, lines]) => ({ label, lines: [...lines] }));
}

/** The written summary the API stored for today (coverage rule already enforced), or the one line saying why it is missing. */
export function BriefingNarrative({ narrative, notice }: { narrative?: MorningBriefing['narrative']; notice?: string }) {
  const blocks = narrativeBlocks(narrative);
  const note = notice;
  if (blocks.length === 0 && !note) return null;
  return (
    <div className="space-y-3">
      {blocks.map((b) => (
        <section key={b.label}>
          <h3 className="mb-1 text-2xs font-semibold uppercase tracking-wider text-ink-dim">{b.label}</h3>
          <ul className="space-y-1">
            {b.lines.map((l, i) => (
              <li key={i} className="text-xs leading-relaxed text-ink">{l}</li>
            ))}
          </ul>
        </section>
      ))}
      {note && <p className="text-2xs italic text-ink-dim">{note}</p>}
    </div>
  );
}
